export default {
  "unableToLoadStations": "Incapace di caricare le stazioni",
  "unableToLoadOutlets": "Incapace di caricare le prese",
  "unableToFetchLaunchLink": "Non è in grado di recuperare il link di lancio",
  "stationUpdated": "Aggiornamento della stazione",
  "stationCreated": "Stazione creata",
  "unableToSaveStation": "Incapace di salvare la stazione",
  "createStation": "Creare la stazione",
  "createRoute": "Crea il percorso",
  "activeStations": "Stazioni attive",
  "stationsReadyToAcceptNewTickets": "Stazioni pronte ad accettare nuovi biglietti.",
  "activeRoutes": "Percorsi attivi",
  "liveRoutingRulesForAllStations": "Regole di routing dal vivo per tutte le stazioni.",
  "ticketsInQueue": "Biglietti in coda",
  "comingFromLiveKDSOrders": "Proveniente da ordini KDS dal vivo.",
  "stationsAtAGlance": "Stazioni a colpo d'occhio",
  "quickOverviewOfYourKitchenStationFleet": "Breve panoramica della vostra flotta di stazioni di cucina.",
  "launchLinks": "Collegamenti di lancio",
  "noStationsConfigured": "Nessuna stazione configurata",
  "createYourFirstKDSStationToBeginRoutingTickets": "Crea la tua prima stazione KDS per iniziare i biglietti di routing.",
  "noOutletLinked": "Nessuna uscita collegata",
  "active": "Attivo",
  "inactive": "Inattivo",
  "launchLink": "Collegamento di lancio",
  "launchLinkCopied": "link di lancio copiato",
  "selectAStationToGenerateALaunchLink": "Selezionare una stazione per generare un link di lancio.",
  "secureStationURLRotatingOTP": "URL stazione sicura + rotante OTP .",
  "stationURL": "URL della stazione",
  "launchLinkNotReady": "Il link di lancio non è pronto",
  "copyStationURL": "Copia l'URL della stazione",
  "onetimePasscode": "Codice di accesso una volta",
  "expiresIn": "Scadenze in",
  "qRPending": "Codice QR in attesa",
  "scanToOpenKDSStation": "Scansione per aprire la stazione KDS",
  "thisStationIsCurrentlyDisabledLaunchLinksWillStillWorkButServiceWillBeLimited": "Questa stazione è attualmente disabilitata. I collegamenti di lancio funzioneranno ancora, ma il servizio sarà limitato.",
  "product": "Prodotto",
  "prepCategory": "Categoria di Prep",
  "productCategory": "Categoria di prodotto",
  "outlet": "Uscita",
  "outletType": "Tipo di uscita",
  "defaultCatchall": "Predefinito catch-all",
  "bar": "Bar",
  "dining": "Ceneri",
  "proShop": "Negozio Pro",
  "halfwayHouse": "Casa a metà strada",
  "chooseWhatTriggersThisRoute": "Scegliere ciò che innesca questa rotta",
  "chooseAMatchingValue": "Scegli un valore corrispondente",
  "chooseAKDSStation": "Scegli una stazione KDS",
  "editRoute": "Modifica della rotta",
  "productsMarkedAsRequiringKDSAreSentToTheFirstMatchingActiveRoute": "I prodotti contrassegnati come che richiedono KDS vengono inviati al primo percorso attivo corrispondente.",
  "moreSpecificRoutesWinAutomaticallyForExampleProductBeatsPrepCategoryAndPrepCategoryBeatsDefault": "I percorsi più specifici vincono automaticamente. Ad esempio, il prodotto batte la categoria Prep, e la categoria Prep batte Default.",
  "whatShouldTriggerThisRoute": "Cosa dovrebbe innescare questa rotta?",
  "chooseTrigger": "Scegli il grilletto",
  "ePOSProduct": "prodotto ePOS",
  "searchForAnEPOSProduct": "Ricerca di un prodotto ePOS",
  "searching": "Ricerca…",
  "searchAndSelectAProduct": "Cerca e seleziona un prodotto.",
  "choosePrepCategory": "Scegli la categoria prep",
  "chooseProductCategory": "Scegli la categoria dei prodotti",
  "chooseOutlet": "Scegli l'outlet",
  "unnamedOutlet": "Presa non nominata",
  "chooseOutletType": "Scegli il tipo di uscita",
  "defaultCatchesKDSrequiredItemsThatDoNotMatchAnotherRoute": "Predefinito cattura gli elementi KDS-required che non corrispondono a un'altra rotta.",
  "sendTicketsTo": "Invia i biglietti a",
  "chooseKDSStation": "Scegli la stazione KDS",
  "routeActive": "Itinerario attivo",
  "useThisRouteWhenItMatches": "Utilizzare questa rotta quando corrisponde.",
  "cancel": "Annulla",
  "saveRoute": "Salvare il percorso",
  "unableToLoadRoutes": "Incapace di caricare i percorsi",
  "routeUpdated": "Percorso aggiornato",
  "routeCreated": "Percorso creato",
  "unableToSaveRoute": "Incapace di salvare il percorso",
  "routeDeleted": "Percorso cancellato",
  "unableToDeleteRoute": "Incapace di eliminare il percorso",
  "default": "Predefinito",
  "routingRules": "Regole di routine",
  "whenThisMatchesSendTicketsThereProductsMarkedAsRequiringKDSAreSentToTheFirstMatchingActiveRoute": "Quando questo corrisponde, inviare i biglietti lì. I prodotti contrassegnati come che richiedono KDS vengono inviati al primo percorso attivo corrispondente.",
  "noRoutingRulesYet": "Non ci sono ancora regole di routing",
  "createADefaultRouteToCatchUnmatchedKDSItems": "Creare un percorso predefinito per catturare gli elementi KDS ineguagliati.",
  "createPrepCategoryRoutesSuchAsDrinksBarAndFoodKitchen": "Creare percorsi di categoria prep come Bevande → Bar e Cibo → Cucina.",
  "edit": "Modifica",
  "deleteRoute": "Eliminare il percorso",
  "thisRoutingRuleWillBeRemovedImmediately": "Questa regola di routing sarà rimossa immediatamente.",
  "stationNameIsRequired": "Il nome della stazione è richiesto",
  "editKDSStation": "Modificare la stazione KDS",
  "createKDSStation": "Creare la stazione KDS",
  "stationName": "Nome della stazione",
  "mainKitchen": "Cucina principale",
  "stationActive": "Stazione attiva",
  "allowThisStationToReceiveRoutedKDSTickets": "Permettere a questa stazione di ricevere i biglietti KDS instradati.",
  "soundEnabled": "Sonoro abilitato",
  "playAToneWhenNewTicketsArrive": "Gioca a tono quando arrivano i nuovi biglietti.",
  "autobumpMinutes": "minuti di auto-bump",
  "automaticallyCompleteItemsAfterThisManyMinutesUse0ToKeepOff": "Completare automaticamente gli oggetti dopo questo molti minuti. Utilizzare 0 per tenere spento.",
  "saveStation": "Salvare la stazione",
  "stations": "Stazioni",
  "selectAStationToManageLaunchLinks": "Selezionare una stazione per gestire i link di lancio.",
  "createYourFirstStation": "Crea la tua prima stazione",
  "stationsPowerTheKDSLayoutAndLaunchLinks": "Le stazioni alimentano il layout KDS e i collegamenti di lancio.",
  "routesDecideWhereKDSrequiredItemsGo": "I percorsi decidono dove vanno gli articoli richiesti da KDS.",
  "disabled": "Disabilitato",
  "editStation": "Modifica della stazione",
  "stationDetails": "Dettagli della stazione",
  "configurationSummaryForThisStation": "Riepilogo configurazione per questa stazione.",
  "on": "Su",
  "off": "Fuori!",
  "autobump": "Avanzamento automatico",
  "technicalKeyKey": "Chiave tecnica: {key}",
  "selectAStationToViewDetails": "Selezionare una stazione per visualizzare i dettagli.",
  "done": "Fine",
  "queued": "In coda",
  "inProgress": "In corso",
  "tapAgainToUndo": "Toccare di nuovo per annullare",
  "order": "Ordinanza",
  "tableTable": "Tabella {table}",
  "countCover": "{count} copertura",
  "countCovers": "{count} coperti",
  "completedAgeAgo": "Completato {age} fa",
  "startAll": "Iniziare tutto",
  "bumpAll": "Bump tutto",
  "reconnectingToKitchenService": "Riconnettersi al servizio cucina...",
  "liveUpdatesDegradedUsingFallbackPolling": "Aggiornamenti in tempo reale degradati, utilizzando inquina...",
  "unableToVerifyOTPCheckTheCodeOrConnectivity": "Non è possibile verificare OTP . Controllare il codice o la connettività.",
  "unableToStartItemConnectionLost": "Non è possibile avviare l'oggetto. Connessione persa.",
  "unableToBumpItemConnectionLost": "Incapace di urtare l'oggetto. Connessione persa.",
  "unableToRecallItemConnectionLost": "Incapace di richiamare l'articolo. Connessione persa.",
  "kitchenDisplay": "Esposizione della cucina",
  "syncing": "Sincronizzazione...",
  "syncedSecondssAgo": "Synced {seconds}s fa",
  "live": "In diretta",
  "reconnecting": "Ricollegamento",
  "lock": "Bloccaggio",
  "noOrdersHereYet": "Non ci sono ancora ordini.",
  "resolvingStation": "Risolvere la stazione...",
  "unableToLocateStation": "Incapace di localizzare la stazione.",
  "enterOnetimeCodeFromManager": "Inserire il codice una volta dal manager",
  "verifyingCode": "Verifica del codice...",
  "terminalAccessRequired": "Accesso al terminale richiesto",
  "codeDigitDigit": "Codice cifra {digit}",
  "refreshCode": "Codice Refresh",
  "requestFailedPleaseTryAgain": "Richiesta fallita, per favore riprovate.",
  "food": "Cibo",
  "drinks": "Bevande",
  "dessert": "Dolcetto",
  "kitchen": "Cucina",
  "other": "Altro",
  "minutesMin": "{minutes} min",
  "deleteRouteConfirm": "Eliminare la rotta?",
  "station": "Stazione KDS",
  "void": "Annullato",
  "recalled": "Richiamato",
  "createStationHeading": "Creare la stazione",
  "stationNotFound": "Questa stazione KDS non è disponibile.",
  "routeNotFound": "Questa regola di routing non esiste più.",
  "invalidSettings": "Controllare le impostazioni della stazione e riprovare.",
  "invalidRouteType": "Scegli un valido criterio di routing.",
  "itemId": "Identificatore dell'oggetto",
  "itemTag": "Codice articolo",
  "menu": "Menu menu menu"
};
